import type { ZoneOutput, Cuboid, OccupancyBox } from './calculator';

function f(v: number): string {
    return Number(v.toFixed(3)).toString();
}

const SEAT_COMMENTS = [
    '% Driver seat',
    '% Passenger seat',
    '% 2nd row driver side',
    '% 2nd row middle seat',
    '% 2nd row passenger side',
];

function formatCuboidBlock(cuboids: Cuboid[]): string {
    const lines: string[] = [];

    for (let seat = 0; seat < 5; seat++) {
        lines.push(SEAT_COMMENTS[seat]);
        for (const c of cuboids.filter(c => c.seatIdx === seat)) {
            lines.push(
                `cuboidDef ${c.seatIdx} ${c.zoneIdx}` +
                `   ${f(c.xMin)}   ${f(c.xMax)}` +
                `   ${f(c.yMin)}   ${f(c.yMax)}` +
                `   ${f(c.zMin)}   ${f(c.zMax)}`
            );
        }
    }

    return lines.join('\n');
}

function formatOccupancyBoxBlock(boxes: OccupancyBox[]): string {
    const lines: string[] = ['% Intruder detection occupancy box definitions'];

    for (const b of boxes) {
        lines.push(
            `% ${b.label}`,
            `occupancyBox ${b.id}` +
            `   ${f(b.xMin)}   ${f(b.xMax)}` +
            `   ${f(b.yMin)}   ${f(b.yMax)}` +
            `   ${f(b.zMin)}   ${f(b.zMax)}`
        );
    }

    return lines.join('\n');
}

export function buildConfigFile(output: ZoneOutput): string {
    const sp = output.sensorPosition;
    const spLine = `sensorPosition   ${f(sp.xOffset)}   ${f(sp.yOffset)}   ${f(sp.zOffset)}   ${f(sp.azimTilt)}   ${f(sp.elevTilt)}`;

    if (output.occupancyBoxes.length > 0) {
        return spLine + '\n\n' + formatOccupancyBoxBlock(output.occupancyBoxes);
    }

    return spLine + '\n\n' + formatCuboidBlock(output.cuboids);
}
